"use strict";

exports.__esModule = true;
exports.ChangePartProcessUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _ChangePartProcessActionElement = require("./ChangePartProcessActionElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ChangePartProcessUserAction = exports.ChangePartProcessUserAction = {
  name: "ChangePartProcess",
  icon: "add",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ChangePartProcessUserActionDefinition.label",
    defaultMessage: "Change Part Process"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ChangePartProcessUserActionDefinition.description",
    defaultMessage: "Enables user to change part process"
  }),
  requiresContexts: ["device"],
  requiresProps: [],
  components: {
    Element: _ChangePartProcessActionElement.ChangePartProcessActionElement
  }
};